import { Add, Close } from '@mui/icons-material';
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import React, { FC, useCallback, useState } from 'react';
import { useTranslation } from '../../services';
import AddAttachmentsForm from './AddAttachmentsForm';

interface AddAttachmentDialogInterface {
	onSubmit: (props: any) => void;
}

const AddAttachmentDialog: FC<AddAttachmentDialogInterface> = ({ onSubmit }) => {
	const { t } = useTranslation();
	const [open, setOpen] = useState(false);

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = useCallback(() => {
		setOpen(false);
	}, []);

	const handleSubmit = useCallback(
		(val: any) => {
			onSubmit(val);
			setOpen(false);
		},
		[onSubmit]
	);

	return (
		<>
			<IconButton
				onClick={handleClickOpen}
				title={t('Add attachment')}
				color="primary"
			>
				<Add />
			</IconButton>
			<Dialog open={open} onClose={handleClose} fullWidth>
				<DialogTitle>
					{t('Add attachment')}
					<IconButton
						aria-label="close"
						onClick={handleClose}
						sx={{
							position: 'absolute',
							right: 8,
							top: 8,
							color: (theme) => theme.palette.grey[500],
						}}
					>
						<Close />
					</IconButton>
				</DialogTitle>
				<DialogContent dividers>
					{open && (
						<AddAttachmentsForm
							onSubmit={handleSubmit}
							values={{ notes: '', requestAttachments: [] }}
						/>
					)}
				</DialogContent>
			</Dialog>
		</>
	);
};

export default AddAttachmentDialog;
